import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Tooltip } from 'react-tooltip';

const MenusContext = createContext();

export const useMenus = () => useContext(MenusContext);

function MenuProvider({ children }) {
    const [cuWidth, setCuWidth] = useState(window.innerWidth);
    const [menuOpen, setMenuOpen] = useState(false);

    // Get current width
    useEffect(() => {
        const handleResize = () => {
            setCuWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // 0px to 767px to return false other wise true
        if (cuWidth <= 991) {
            setMenuOpen(false);
        } else if (cuWidth >= 992 && cuWidth <= 1399) {
            setMenuOpen(false);
        } else {
            setMenuOpen(true);
        }
    }, [cuWidth]);

    const [darkMode, setDarkMode] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches
    );

    // Get current mode
    useEffect(() => {
        const storedMode = localStorage.getItem('darkMode');
        if (storedMode) {
            setDarkMode(storedMode === 'true');
        }
    }, []);

    // Set current mode
    useEffect(() => {
        localStorage.setItem('darkMode', darkMode.toString());
        document.documentElement.classList.toggle('dark', darkMode);
    }, [darkMode]);

    // Set value
    const value = useMemo(() => {
        // Handle color mode
        const handleColorMode = () => {
            setDarkMode((prevDarkMode) => !prevDarkMode);
        };

        // Handle menu collapse
        const handleMenuCollapse = () => {
            setMenuOpen((cuData) => !cuData);
        };

        return {
            menuOpen,
            setMenuOpen,
            handleColorMode,
            handleMenuCollapse,
            cuWidth
        };
    }, [cuWidth, menuOpen]);

    return (
        <MenusContext.Provider value={value}>
            {children}
            <Tooltip
                id="menuTooltip"
                place="right"
                style={{ backgroundColor: '#00916E', zIndex: '9999999999' }}
            />
            <Tooltip
                id="tblTooltip"
                style={{
                    backgroundColor: '#CDD5D831',
                    color: '#042B3A90',
                    zIndex: '9999999999',
                    fontSize: '12px',
                    padding: '4px 8px'
                }}
            />
        </MenusContext.Provider>
    );
}

export default MenuProvider;
